// Bonus categories (Point 17). Values come from the backend BonusTypeEnum.
export const BonusTypeEnum = Object.freeze({
  Performance: 1,
  Signing: 2,
  Annual: 3,
  Spot: 4,
  Other: 5,
});

export const BonusTypeEnumLabel = Object.freeze({
  [BonusTypeEnum.Performance]: "Performance",
  [BonusTypeEnum.Signing]: "Signing",
  [BonusTypeEnum.Annual]: "Annual",
  [BonusTypeEnum.Spot]: "Spot",
  [BonusTypeEnum.Other]: "Other",
});

// Options for an AntD Select (bonus type picker).
export const BonusTypeOptions = Object.entries(BonusTypeEnumLabel).map(([value, label]) => ({
  value: Number(value),
  label,
}));
